import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetAward } from "./useGetAward"
import { AwardEntity } from "../../Objects/Awards/AwardEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useSaveAward = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetAward } = useGetAward()

  const handleSavesAward = async (awardChange: AwardEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = null

      if (awardChange.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.AWARD.PUT}/${awardChange.id}`, awardChange.toJSON())
      } else {
        response = await PostFormRequest(API_ROUTES.AWARD.CREATE, awardChange.toJSON())
      }

      if (response.success) {
        await handleGetAward(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSavesAward,
  }
}
